import $ from 'jquery';

import routes from './js/routes';
import signup from './js/auth';

import { Application } from './js/core/application';
import AppState from './js/core/app.state';
import Config from './js/config';
import { routing } from './js/core/routing';
import { promisify, requestify } from './js/utils/promisify';
import { hashify } from './js/utils/arrays';
import rng from 'uuid/lib/rng';





const [q] = location.search.substring( 1 )
    .split( '&' )
    .filter( p => 0 === p.indexOf( 'locale=' ) );
    
if (q) {
    Config.locale( q.replace( 'locale=', '' ) );
    location.assign( location.href
        .replace( `?${q}`, '' )
        .replace( `&${q}`, '' ) );
}

const start = !q ? Promise.resolve() : Promise.reject();





window.$ = window.jQuery = $;
require( 'bootstrap' );

const app = new Application()
const appState = new AppState();

start
    .then( () => requestify( $.getJSON( `/languages?apiVersion=2.0`) ) )
    .then( languages => {
        Config.languages( languages );

        const [main] = languages.filter( lang => lang.main );
        const hash = hashify( languages
            .filter( lang => lang.visible )
            .map( lang => lang.code ) );

        if (!Config.locale())
            Config.locale( main.code );
        else if (!hash[Config.locale()])
            Config.locale( main.code );
    } )
    .then( () => requestify( signup ) )
    .then( () => {
        const baselayers = requestify( $.getJSON( `/baselayers?apiVersion=2.0` ) )
            .then( layers => layers.filter( layer => layer.main )[0] )
            .then( ({ className, firstKey, options } ) => {
                const Class = className.split( '.' )
                    .reduce( (obj, prop) => obj[prop], window );
                Config.mapClass( { Class, 
                    firstAttr: firstKey, 
                    options: eval( `(${options || '{}'})` ), } );
            } );

        const mapextent = requestify( $.getJSON( `/mapextent` ) )
            .then( ({ mapExtent: { extent: { minX, minY, maxX, maxY } } }) => 
                Config.mapExtent( [minX, minY, maxX, maxY] ) );

        const settings = requestify( $.getJSON( `/mapsurfer/settings` ) )
            .then( c => c.title )
            .catch( () => 'ActiveMap' )
            .then( title => Config.title( title ) );

        const ru = Config.locale() != 'ru' ? {} : hashify( [
            "Asia/Anadyr",
            "Asia/Barnaul",
            "Asia/Chita",
            "Asia/Irkutsk",
            "Asia/Kamchatka",
            "Asia/Khandyga",
            "Asia/Krasnoyarsk",
            "Asia/Magadan",
            "Asia/Novokuznetsk",
            "Asia/Novosibirsk",
            "Asia/Omsk",
            "Asia/Sakhalin",
            "Asia/Srednekolymsk",
            "Asia/Tomsk",
            "Asia/Vladivostok",
            "Asia/Yakutsk",
            "Asia/Yekaterinburg",
            "Europe/Astrakhan",
            "Europe/Kaliningrad",
            "Europe/Kirov",
            "Europe/Minsk",
            "Europe/Moscow",
            "Europe/Samara",
            "Europe/Saratov",
            "Europe/Simferopol",
            "Europe/Ulyanovsk",
            "Europe/Volgograd"
        ] );

        const fn = ({ id, name }) => {
            const time = +name.replace( '(GMT', '' ).split( ':' )[0];
            const title = name.replace( /^[^ ]+ /, '' );
            const abs = Math.abs( time );
            return [!ru[id], abs < 10 ? '0' + abs : abs, time, title];
        };

        const timezones = requestify( $.getJSON( `/mapsurfer/timezones?token=${Config.token()}&lang=${Config.locale()}` ) )
            .then( zones => zones.map( ({ zoneId, name }) => ({ id: zoneId, name }) ) )
            .then( zones => zones.sort( (zA, zB) => 
                    fn( zA ) < fn( zB )
                        ? -1
                        : fn( zA ) > fn( zB )
                            ? 1 : 0 ) )
            .then( zones => Config.timezones( zones ) );

        return Promise.all( [baselayers, mapextent, settings, timezones] );
    } )
    .then( () => app.render() )
    .then( () => routing( app, appState, routes ) )
    .catch( reason => console.error( reason ) );





// WEBPACK FOOTER //
// ./src/issues.js